import type { UseProductAssociationsReturn } from '@shopware-pwa/composables-next'
import { computed, type ComputedRef, ref } from 'vue'
import type { Schemas } from '#shopware'
import { useShopwareContext } from '#imports'

function _useProductAssociations(
  product: ComputedRef<Schemas['Product']>
): UseProductAssociationsReturn & {
  loadAssociations: () => Promise<void>
} {
  if (!product.value)
    throw new Error('[useProductAssociations]: Product is not provided.')

  const { apiClient } = useShopwareContext()
  const isLoading = ref(false)
  const associations = ref<Schemas['CrossSellingElementCollection']>([])

  const loadAssociations = async () => {
    isLoading.value = true
    try {
      const { data } = await apiClient.invoke(
        'readProductCrossSellings post /product/{productId}/cross-selling',
        {
          pathParams: { productId: product.value.parentId || product.value.id },
        }
      )
      associations.value = data
    } catch (error) {
      console.error('[useProductAssociations][loadAssociations][error]:', error)
    } finally {
      isLoading.value = false
    }
  }

  return {
    isLoading: computed(() => isLoading.value),
    productAssociations: computed(() => associations.value),
    loadAssociations,
  }
}

export const useProductAssociations = createSharedComposable(
  _useProductAssociations
)
